import ApplicationAdapter from 'lumen/adapters/application';

// CustomTagValue records are never persisted individually.
// All writes go through the bulk PATCH in the organize controller
// (saveCustomTagValues → POST /property-tags/custom/).
// Block the Ember Data per-record update path so accidental record.save()
// calls fail loudly instead of silently hitting the wrong endpoint.
export default class CustomTagValueAdapter extends ApplicationAdapter {
  override urlForUpdateRecord(): never {
    throw new Error(
      'CustomTagValue does not support per-record saves. Use the bulk PATCH via saveCustomTagValues instead.',
    );
  }
}
